import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import ProfileSection from './components/ProfileSection';
import TopicWall from './components/TopicWall';
import LatestLeaks from './components/LatestLeaks';
import CollectionIndex from './components/CollectionIndex';
import CommunityPosts from './components/CommunityPosts';
import CommentsSection from './components/CommentsSection';
import SubscribeCta from './components/SubscribeCta';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <TopicWall />
        <ProfileSection />
        <LatestLeaks />
        <CollectionIndex />
        <CommunityPosts />
        <CommentsSection />
        <SubscribeCta />
      </main>
      <SiteFooter />
    </div>
  );
}